// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4f-5";
export var imageContainer = "_4f-4";
export var metricsGrid = "_4f-2";
export var productDetailContainer = "_4f-1";
export var productListContainer = "_4f-0";
export var subscriberTableContainer = "_4f-3";